module.exports = __webpack_public_path__ + "static/monty-signiture-f81fbc9667d89bbf08982d862b9b91e0.png";